export default "__VITE_ASSET__JFd11VS0__"